import styled from "styled-components";

export const SAddProjectModalSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
